import {Column, DataTable, Skeleton} from 'primereact';
import React, {useEffect, useState} from 'react';
import {formatear2Decimales} from "../../../Commons/Scripts/Utils/formatear";
import {useForm} from "../../../Commons/Scripts/Hooks/useForm";
import {UrlReporte, useImprimir} from "../../../Commons/Scripts/Hooks/useImprimir";
import {SimpleForm} from "../../../Commons/Scripts/Componentes/Form";
import {SelectField} from "../../../Commons/Scripts/Componentes/SelectField";
import {DateField} from "../../../Commons/Scripts/Componentes/DateField";
import {Button2} from "../../../Commons/Scripts/Componentes/Button";
import {Message, useMessage} from "../../../Commons/Scripts/Componentes/Message";
import {CxcReporteService} from "../Services/cxc-reporte-service";
import { RadioButtonField } from "../../../Commons/Scripts/Componentes/RadioButtonField";
import { useAuthentication } from '../../../Commons/Scripts/Hooks';
import { PAIS_CODIGO_DO, PAIS_CODIGO_EC, PAIS_CODIGO_CR, PAIS_CODIGO_GT, PAIS_CODIGO_SV } from '../../../Commons/Scripts/Utils/constants';

const origin = window.location.origin;

function OcultarCero({ children, valor }) {
  return <React.Fragment>{valor === 0 ? null : <span>{children}</span>}</React.Fragment>;
}

const BodyCliente = (data, field, setExpandedRows, esNumero = false) => {
  return (
    <div
      style={{ width: "100%", cursor: "pointer" }}
      onClick={() => {
        const key = data.ClienteIdSec;

        setExpandedRows((prev) => {
          if (prev?.some((p) => p.ClienteIdSec === key)) {
            return prev?.filter((p) => p.ClienteIdSec !== key);
          } else {
            return [...(prev || []), data];
          }
        });
      }}
    >
      {esNumero && <OcultarCero valor={data[field]}>{formatear2Decimales(data[field])}</OcultarCero>}
      {!esNumero && data[field]}
    </div>
  );
};

function TablaSaldoAntiguedad({ facturas, indice, loading, expandedRows, setExpandedRows }) {
    const { usuario } = useAuthentication();
    const [internacionalData, setInternacionalData] = useState({
        NCFheader: "NCF",
    });

    useEffect(() => {
        switch (usuario?.Compania?.Internacional) {
            case PAIS_CODIGO_EC:
                setInternacionalData({
                    NCFheader: "Comprobante"
                });
                break;
            case PAIS_CODIGO_GT:
                setInternacionalData({
                    NCFheader: "Comprobante"
                });
                break;
            case PAIS_CODIGO_SV:
                setInternacionalData({
                    NCFheader: "DTE"
                });
                break;
            case PAIS_CODIGO_CR:
                setInternacionalData({
                    NCFheader: "Comprobante"
                });
                break;
            case PAIS_CODIGO_DO:
            default:
                setInternacionalData({
                    NCFheader: "NCF"
                });
                break;
        }
    }, [usuario?.Compania?.Internacional]);

  const grupoMoneda = facturas?.reduce((acc, item) => {
    const moneda = acc.find((moneda) => moneda.MonedaNombre === item.MonedaNombre);

    if (!moneda) {
      acc.push(item);
    }

    return acc;
  }, []);

  const grupoCliente = facturas?.reduce((acc, item) => {
    const clienteIndex = acc.findIndex(
      (cliente) => cliente.ClienteIdSec === item.ClienteIdSec && cliente.MonedaNombre === item.MonedaNombre
    );

    if (clienteIndex !== -1) {
      const cliente = { ...acc[clienteIndex] };
      cliente.documentos.push(item);
      cliente._0a30 += item._0a30;
      cliente._31a60 += item._31a60;
      cliente._61a90 += item._61a90;
      cliente.mayor90 += item.mayor90;
      cliente.BalanceActual += item.BalanceActual;
      acc = [...acc.slice(0, clienteIndex), cliente, ...acc.slice(clienteIndex + 1)];
    } else {
      acc.push({
        ...item,
        documentos: [item],
      });
    }

    return acc;
  }, []);

  const rowExpansionTemplate = (moneda, cliente) => {
    const filtroMoneda = facturas.filter((factura) => factura.MonedaNombre === moneda.MonedaNombre);

    const filtroCliente = filtroMoneda.filter((factura) => factura.ClienteIdSec === cliente.ClienteIdSec);

    function crearColumna(campo, cabezera, key) {
      return (
        <Column
          key={key}
          style={{ textAlign: "right" }}
          headerClassName="alinear-derecha"
          body={(item) => {
            const link = `${origin}/Facturacion/factura_edit.aspx?IdSec=${item.FacturaIdSec}`;
            return (
              <OcultarCero valor={item[campo]}>
                <a className="link" href={link} target="_blank">
                  {formatear2Decimales(item[campo])}
                </a>
              </OcultarCero>
            );
          }}
          header={cabezera}
          footer={() => {
            const total = filtroCliente.reduce((sum, item) => sum + item[campo], 0);

            // {filtroCliente?.[0]?.MonedaSimbolo}

            return <OcultarCero valor={total}>{formatear2Decimales(total)}</OcultarCero>;
          }}
        />
      );
    }

    const columnas = [
      crearColumna("_0a30", "0-30", "0a30"),
      crearColumna("_31a60", "31-60", "31a60"),
      crearColumna("_61a90", "61-90", "61a90"),
      crearColumna("mayor90", "> 90", "mayor90"),
      crearColumna("MontoOriginal", "Monto Original", "montoOriginal"),
      crearColumna("BalanceActual", "Balance Actual", "balanceActual"),
    ];

    return (
      <DataTable value={filtroCliente}>
        <Column
          headerClassName="alinear-derecha"
          style={{ textAlign: "right" }}
          body={(item) => {
            const link = `${origin}/Facturacion/factura_edit.aspx?IdSec=${item.FacturaIdSec}`;

            return (
              <a className="link" href={link} target="_blank">
                {item.FacturaIdSec}
              </a>
            );
          }}
          header="Id"
        />
        <Column
                body={(item) => {
                    const link = `${origin}/Facturacion/factura_edit.aspx?IdSec=${item.FacturaIdSec}`;

                    return (
                        <a className="link" href={link} target="_blank">
                            {item.FacturaNCF}
                        </a>
                    );
                }}
                header={internacionalData?.NCFheader || "NCF"}
        />
        <Column
          headerClassName="alinear-derecha"
          style={{ textAlign: "right" }}
          body={(item) => {
            const match = item?.FechaFactura?.match(/\d+/);
            const fechaMilisegundos = match ? Number(match[0]) : null;

            return <span>{new Date(fechaMilisegundos).toLocaleDateString()}</span>;
          }}
          header="Fecha"
        />
        <Column
          headerClassName="alinear-derecha"
          style={{ textAlign: "right" }}
          body={(item) => {
            const match = item?.FechaVencimiento?.match(/\d+/);
            const fechaMilisegundos = match ? Number(match[0]) : null;

            return <span>{new Date(fechaMilisegundos).toLocaleDateString()}</span>;
          }}
          header="Vencimiento"
        />
        <Column style={{ textAlign: "right" }} headerClassName="alinear-derecha" field="DiasAntiguedad" header="Días" />
        {columnas}
      </DataTable>
    );
  };

  return (
    <div>
      {grupoMoneda?.length > 0 &&
        grupoMoneda?.map((moneda, index) => {
          const grupoClienteFiltrado = grupoCliente.filter((factura) => factura.MonedaNombre === moneda.MonedaNombre);

          return (
            <div key={index}>
              <div style={{ padding: "1rem 0", fontSize: "12px" }}>
                <b>Moneda:</b> {moneda.MonedaNombre}
              </div>
              <DataTable
                id="grid"
                value={grupoClienteFiltrado}
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e.data)}
                rowExpansionTemplate={(item) => rowExpansionTemplate(moneda, item)}
              >
                <Column
                  expander
                  style={{ width: "45px" }}
                  body={(rowData) => {
                    const isExpanded = expandedRows?.some((p) => p.ClienteIdSec === rowData.ClienteIdSec);

                    return (
                      <div
                        onClick={() => {
                          const key = rowData.ClienteIdSec;

                          setExpandedRows((prev) => {
                            if (prev?.some((p) => p.ClienteIdSec === key)) {
                              return prev?.filter((p) => p.ClienteIdSec !== key);
                            } else {
                              return [...(prev || []), rowData];
                            }
                          });
                        }}
                        className={`p-row-toggler ${isExpanded ? "expanded" : ""}`}
                      >
                        <i className="pi pi-chevron-right"></i>
                      </div>
                    );
                  }}
                />
                <Column
                  headerClassName="alinear-derecha"
                  style={{ textAlign: "right" }}
                  body={(item) => BodyCliente(item, "ClienteIdSec", setExpandedRows)}
                  field="ClienteIdSec"
                  header="Id"
                />
                <Column
                  body={(item) => BodyCliente(item, "ClienteNombre", setExpandedRows)}
                  field="ClienteNombre"
                  header="Cliente"
                />
                <Column
                  body={(item) => BodyCliente(item, "ClienteContacto", setExpandedRows)}
                  field="ClienteContacto"
                  header="Contacto"
                />
                <Column
                  headerClassName="alinear-derecha"
                  style={{ textAlign: "right" }}
                  body={(item) => BodyCliente(item, "ClienteTelefonoPrincipal", setExpandedRows)}
                  field="ClienteTelefonoPrincipal"
                  header="Teléfono"
                />
                <Column
                  headerClassName="alinear-derecha"
                  style={{ textAlign: "right" }}
                  body={(item) => BodyCliente(item, "LimiteCredito", setExpandedRows, true)}
                  field="LimiteCredito"
                  header="Límite de Crédito"
                />
                <Column
                  headerClassName="alinear-derecha"
                  style={{ textAlign: "right" }}
                  body={(item) => BodyCliente(item, "_0a30", setExpandedRows, true)}
                  header="0-30"
                />
                <Column
                  headerClassName="alinear-derecha"
                  style={{ textAlign: "right" }}
                  body={(item) => BodyCliente(item, "_31a60", setExpandedRows, true)}
                  header="31-60"
                />
                <Column
                  headerClassName="alinear-derecha"
                  style={{ textAlign: "right" }}
                  body={(item) => BodyCliente(item, "_61a90", setExpandedRows, true)}
                  header="61-90"
                />
                <Column
                  headerClassName="alinear-derecha"
                  style={{ textAlign: "right" }}
                  body={(item) => BodyCliente(item, "mayor90", setExpandedRows, true)}
                  header="> 90"
                />
                <Column
                  headerClassName="alinear-derecha"
                  style={{ textAlign: "right" }}
                  body={(item) => BodyCliente(item, "BalanceActual", setExpandedRows, true)}
                  header="Total"
                />
              </DataTable>
            </div>
          );
        })}

      {loading && indice === 1 && (
        <DataTable showHeaders={false} value={Array.from({ length: 30 })}>
          <Column body={<Skeleton style={{ height: "40px" }} />} />
        </DataTable>
      )}
    </div>
  );
}

function TablaSaldoAntiguedadResumido({ filtrarFacturas, facturas, indice, loading }) {
  const grupoMonedas = facturas?.reduce((acc, item) => {
    const moneda = acc.find((moneda) => moneda.MonedaNombre === item.MonedaNombre);

    if (!moneda) {
      acc.push(item);
    }

    return acc;
  }, []);

  const grupoClientes = facturas?.reduce((acc, item) => {
    const clienteIndex = acc.findIndex(
      (cliente) => cliente.ClienteIdSec === item.ClienteIdSec && cliente.MonedaNombre === item.MonedaNombre
    );

    if (clienteIndex === -1) {
      acc.push(item);
    } else {
      const cliente = { ...acc[clienteIndex] };

      cliente._0a30 += item._0a30;
      cliente._31a60 += item._31a60;
      cliente._61a90 += item._61a90;
      cliente.mayor90 += item.mayor90;
      cliente.MontoOriginal += item.MontoOriginal;
      cliente.BalanceActual += item?.BalanceActual ?? 0;

      acc[clienteIndex] = cliente;
    }
    return acc;
  }, []);

  return (
    <React.Fragment>
      {grupoMonedas?.length > 0 &&
        grupoMonedas?.map((moneda, index) => {
          const grupoClientesFiltrado = grupoClientes.filter((factura) => factura.MonedaNombre === moneda.MonedaNombre);

          return (
            <div key={index}>
              <h3>
                <b>Facturas en Moneda:</b> {moneda.MonedaNombre}
              </h3>

              <DataTable id="grid" value={grupoClientesFiltrado}>
                <Column
                  headerClassName="alinear-derecha"
                  style={{ textAlign: "right" }}
                  body={(item) => {
                    const link = `${origin}/CxC/cliente_edit.aspx?IdSec=${item.ClienteIdSec}`;

                    return (
                      <a className="link" href={link} target="_blank">
                        {item.ClienteIdSec}
                      </a>
                    );
                  }}
                  field="ClienteIdSec"
                  header="Cliente Id"
                />
                <Column
                  className="link"
                  body={(item) => {
                    const link = `${origin}/CxC/cliente_edit.aspx?IdSec=${item.ClienteIdSec}`;

                    return (
                      <a className="link" href={link} target="_blank">
                        {item.ClienteNombre}
                      </a>
                    );
                  }}
                  header="Nombre"
                />
                <Column field="ClienteContacto" header="Contacto" />
                <Column field="Condicion" header="Condición" />
                <Column
                  headerClassName="alinear-derecha"
                  style={{ textAlign: "right" }}
                  field="LimiteCredito"
                  header="Límite de crédito"
                />
                <Column
                  headerClassName="alinear-derecha"
                  style={{ textAlign: "right" }}
                  body={(item) => (
                    <OcultarCero valor={item._0a30}>
                      <span
                        valor={item._0a30}
                        className="link"
                        onClick={() => {
                          filtrarFacturas(item.ClienteIdSec);
                        }}
                      >
                        {formatear2Decimales(item._0a30)}
                      </span>
                    </OcultarCero>
                  )}
                  header="0-30"
                  footer={() => (
                    <span>{formatear2Decimales(grupoClientesFiltrado.reduce((sum, item) => sum + item._0a30, 0))}</span>
                  )}
                />
                <Column
                  headerClassName="alinear-derecha"
                  style={{ textAlign: "right" }}
                  body={(item) => (
                    <OcultarCero valor={item._31a60}>
                      <span
                        valor={item._31a60}
                        className="link"
                        onClick={() => {
                          filtrarFacturas(item.ClienteIdSec);
                        }}
                      >
                        {formatear2Decimales(item._31a60)}
                      </span>
                    </OcultarCero>
                  )}
                  header="31-60"
                  footer={() => (
                    <span>
                      {formatear2Decimales(grupoClientesFiltrado.reduce((sum, item) => sum + item._31a60, 0))}
                    </span>
                  )}
                />
                <Column
                  headerClassName="alinear-derecha"
                  style={{ textAlign: "right" }}
                  body={(item) => (
                    <OcultarCero valor={item._61a90}>
                      <span
                        valor={item._61a90}
                        className="link"
                        onClick={() => {
                          filtrarFacturas(item.ClienteIdSec);
                        }}
                      >
                        {formatear2Decimales(item._61a90)}
                      </span>
                    </OcultarCero>
                  )}
                  header="61-90"
                  footer={() => (
                    <span>
                      {formatear2Decimales(grupoClientesFiltrado.reduce((sum, item) => sum + item._61a90, 0))}
                    </span>
                  )}
                />
                <Column
                  headerClassName="alinear-derecha"
                  style={{ textAlign: "right" }}
                  body={(item) => (
                    <OcultarCero valor={item.mayor90}>
                      <span
                        valor={item.mayor90}
                        className="link"
                        onClick={() => {
                          filtrarFacturas(item.ClienteIdSec);
                        }}
                      >
                        {formatear2Decimales(item.mayor90)}
                      </span>
                    </OcultarCero>
                  )}
                  header="> 90"
                  footer={() => (
                    <span>
                      {formatear2Decimales(grupoClientesFiltrado.reduce((sum, item) => sum + item.mayor90, 0))}
                    </span>
                  )}
                />
                <Column
                  headerClassName="alinear-derecha"
                  style={{ textAlign: "right" }}
                  body={(item) => (
                    <OcultarCero valor={item.BalanceActual}>
                      <span
                        valor={item.BalanceActual}
                        className="link"
                        onClick={() => {
                          filtrarFacturas(item.ClienteIdSec);
                        }}
                      >
                        {formatear2Decimales(item.BalanceActual)}
                      </span>
                    </OcultarCero>
                  )}
                  field="BalanceActual"
                  header="Balance"
                  footer={() => (
                    <span>
                      {formatear2Decimales(grupoClientesFiltrado.reduce((sum, item) => sum + item.BalanceActual, 0))}
                    </span>
                  )}
                />
              </DataTable>
            </div>
          );
        })}

      {loading && indice === 1 && (
        <DataTable showHeaders={false} value={Array.from({ length: 30 })}>
          <Column body={<Skeleton style={{ height: "40px" }} />} />
        </DataTable>
      )}
    </React.Fragment>
  );
}

function Formulario({
  clientes,
  tiposClientes,
  tiposFacturas_,
  vendedores,
  tiendas,
  periodos,
  antiguedad,
  monedas,
  loadingDatos,
  onSubmit,
  valorInicial = {},
  onChange,
  filtro,
  tipo,
  where,
}) {
  const { useEffect } = React;
  const form = useForm(valorInicial);

  const [loadingPdf, handlePdf] = useImprimir(UrlReporte.SALDO_ANTIGUEDAD_CXC, "PDF");
  const [loadingExcel, handleExcel] = useImprimir(UrlReporte.SALDO_ANTIGUEDAD_CXC, "Excel");
  const [loadingCsv, handleCsv] = useImprimir(UrlReporte.SALDO_ANTIGUEDAD_CXC, "CSV");

  useEffect(() => {
    const cliente = clientes?.find((c) => c.value === Number(filtro?.clienteIdSec));
    if (cliente) {
      form.setValue("cliente", [cliente]);
    }
  }, [filtro]);

  useEffect(() => {
    form.setValue("tipo", tipo || "detalle");
  }, [tipo]);

  const handleSubmit = () => {
    onSubmit(form.values);
  };

  return (
    <SimpleForm formulario={form} onChange={onChange}>
      <div className="row">
        <SelectField
          isMulti
          name="cliente"
          opciones={clientes || []}
          label="Cliente"
          placeholder="Todos"
          isLoading={loadingDatos}
          width="400px"
        />
      </div>

      <div className="row">
        <SelectField
          name="tipoCliente"
          opciones={tiposClientes || []}
          placeholder="Todos"
          label="Tipo Cliente"
          isLoading={loadingDatos}
          opcionPorDefecto={true}
        />
        <SelectField
          name="factura"
          opciones={tiposFacturas_ || []}
          label="Factura"
          placeholder="Todos"
          isRow
          isLoading={loadingDatos}
          opcionPorDefecto={true}
        />
      </div>

      <div className="row">
        <SelectField
          isMulti
          name="vendedor"
          opciones={vendedores || []}
          label="Vendedor"
          placeholder="Todos"
          isLoading={loadingDatos}
        />
      </div>

      <div className="row">
        <SelectField
          isMulti
          name="tienda"
          opciones={tiendas || []}
          label="Tienda"
          placeholder="Todos"
          isLoading={loadingDatos}
        />
      </div>

      <div className="row">
        <SelectField
          name="periodo"
          opciones={periodos || []}
          label="Periodo"
          placeholder="Seleccione un periodo"
          isLoading={loadingDatos}
          opcionPorDefecto={true}
        />
      </div>

      <div className="row">
        <DateField name="fechaFin" label="Fecha Fin" mostrarIcono={true} />
      </div>

      <div className="row">
        <SelectField
          name="antiguedad"
          opciones={antiguedad || []}
          label="Antigüedad"
          placeholder="Todas"
          isLoading={loadingDatos}
          opcionPorDefecto={true}
        />
        <SelectField
          name="moneda"
          opciones={monedas || []}
          label="Moneda"
          placeholder="Todas"
          isRow
          isLoading={loadingDatos}
          opcionPorDefecto={true}
        />
      </div>

      <div className="row">
        <label className="label">Tipo</label>
        <div className="control">
          <div style={{ display: "flex", alignItems: "center", gap: "0 5px" }}>
            <RadioButtonField name="tipo" label="Detalle" value="detalle" />
            <RadioButtonField name="tipo" label="Resumido" value="resumido" />
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "0 5px",
          margin: "10px 0 10px 125px",
        }}
      >
        <Button2 texto="Buscar" icono="buscar" onClick={handleSubmit} />
        <Button2
          texto="PDF"
          icono="imprimir"
          onClick={() => handlePdf({ TipoReporte: form.values?.tipo === "resumido" ? "U" : "", ...where })}
          loading={loadingPdf}
        />
        <Button2
          texto="Excel"
          icono="excel"
          onClick={() => handleExcel({ TipoReporte: form.values?.tipo === "resumido" ? "U" : "", ...where })}
          loading={loadingExcel}
        />
        <Button2
          texto="CSV"
          icono="excel"
          onClick={() => handleCsv({ TipoReporte: form.values?.tipo === "resumido" ? "U" : "", ...where })}
          loading={loadingCsv}
        />
      </div>
    </SimpleForm>
  );
}

export function SaldoAntiguedad() {
  const { messages, typeMessages, handleException, clearMessages } = useMessage();
  const [expandedRows, setExpandedRows] = useState(null);

  const [loading, setLoading] = useState(false);
  const [facturas, setFacturas] = useState([]);
  const [total, setTotal] = useState(0);

  const [loadingDatos, setLoadingDatos] = useState(false);
  const [clientes, setClientes] = useState();
  const [tiposClientes, setTiposClientes] = useState();
  const [tiposFacturas, setTiposFacturas] = useState();
  const [tiposFacturas_, setTiposFacturas_] = useState();
  const [vendedores, setVendedores] = useState();
  const [tiendas, setTiendas] = useState();
  const [periodos, setPeriodos] = useState();
  const [antiguedad, setAntiguedad] = useState();
  const [monedas, setMonedas] = useState();

  const [where, setWhere] = useState({
    Periodo: "EM",
    IndiceDePagina: 0,
    CantidadPorPagina: 50,
  });

  const [tipo, setTipo] = useState("detalle");
  const [filtro, setFiltro] = useState();

  const totalPaginas = Math.ceil(total / where.CantidadPorPagina);
  const indice = (where.IndiceDePagina ?? 0) + 1;

  useEffect(() => {
    setLoading(true);
    clearMessages();

    CxcReporteService.consultarSaldoAntiguedad(where)
      .then((res) => {
          setFacturas((prevFacturas) => {
              const idsExistentes = new Set(prevFacturas.map(f => f.FacturaIdSec));
              const nuevosUnicos = (res?.Resultados || []).filter(f => !idsExistentes.has(f.FacturaIdSec));
              return [...prevFacturas, ...nuevosUnicos];
          });
          setTotal(res?.Total ?? 0);
      })
      .catch((err) => {
        handleException(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [where]);

  useEffect(() => {
    setLoadingDatos(true);
    clearMessages();

    Promise.all([
      CxcReporteService.consultarClientes(),
      CxcReporteService.consultarTiposClientes(),
      CxcReporteService.consultarTiposFacturas(),
      CxcReporteService.consultarTiposFacturas_(),
      CxcReporteService.consultarVendedores(),
      CxcReporteService.consultarTiendas(),
      CxcReporteService.consultarPeriodos(),
      CxcReporteService.consultarAntiguedad(),
      CxcReporteService.consultarMonedas(),
    ])
      .then((res) => {
        const clientes = res[0]?.map((cliente) => {
          return {
            value: cliente.IdSec,
            label: cliente.Nombre,
          };
        });
        const tiposClientes = res[1]?.map((tipoCliente) => {
          return {
            value: tipoCliente.IdSec,
            label: tipoCliente.Nombre,
          };
        });
        const tiposFacturas = res[2]?.map((tipoFactura) => {
          return {
            value: tipoFactura.Value,
            label: tipoFactura.Label,
          };
        });
        const tiposFacturas_ = res[3]?.map((tipoFactura) => {
          return {
            value: tipoFactura.Value,
            label: tipoFactura.Label,
          };
        });
        const vendedores = res[4]?.map((vendedor) => {
          return {
            value: vendedor.IdSec,
            label: vendedor.Nombre,
          };
        });
        const tiendas = res[5]?.map((tienda) => {
          return {
            value: tienda.IdSec,
            label: tienda.Nombre,
          };
        });
        const periodos = res[6]?.map((periodo) => {
          return {
            value: periodo.Value,
            label: periodo.Label,
          };
        });
        const antiguedad = res[7]?.map((a) => {
          return {
            value: a.Value,
            label: a.Label,
          };
        });
        const monedas = res[8]?.map((moneda) => {
          return {
            value: moneda.IdSec,
            label: moneda.Descripcion,
          };
        });

        setClientes(clientes);
        setTiposClientes(tiposClientes);
        setTiposFacturas(tiposFacturas);
        setTiposFacturas_(tiposFacturas_);
        setVendedores(vendedores);
        setTiendas(tiendas);
        setPeriodos(periodos);
        setAntiguedad(antiguedad);
        setMonedas(monedas);
      })
      .catch((error) => {
        handleException(error);
      })
      .finally(() => {
        setLoadingDatos(false);
      });
  }, []);

  const filtrarFacturas = (clienteIdSec) => {
    setTipo("detalle");
    setFiltro({
      clienteIdSec: clienteIdSec,
    });
    setExpandedRows();
  };

  const handleFiltrar = (filtros) => {
    setFacturas([]);
    setTotal(0);
    setWhere({
      ...filtros,
      IndiceDePagina: 0,
      CantidadPorPagina: 50,
    });
  };

  const handleMostrarMas = () => {
    setWhere((prevWhere) => ({
      ...prevWhere,
      IndiceDePagina: prevWhere.IndiceDePagina + 1,
    }));
  };

  const handleChange = (formulario) => {
    if (filtro !== undefined && filtro !== null) {
      setFacturas([]);
      setTotal(0);
      setWhere((prevWhere) => ({ ...prevWhere, ClienteIdSecList: formulario.cliente?.map((c) => c.value) }));
      setFiltro();
    }
  };

  return (
    <div>
      <Message messages={messages} type={typeMessages} />
      <Formulario
        clientes={clientes}
        tiposClientes={tiposClientes}
        tiposFacturas={tiposFacturas}
        tiposFacturas_={tiposFacturas_}
        vendedores={vendedores}
        tiendas={tiendas}
        periodos={periodos}
        antiguedad={antiguedad}
        monedas={monedas}
        loadingDatos={loadingDatos}
        onSubmit={(formulario) => {
          let fechaFin = new Date(formulario.fechaFin);
          const ahora = new Date();
          fechaFin.setHours(ahora.getHours(), ahora.getMinutes(), ahora.getSeconds(), ahora.getMilliseconds());

          const filtros = {
            ClienteIdSecList: formulario.cliente?.map((cliente) => cliente.value),
            FacturaEsProforma: formulario.factura?.value === "true",
            TipoClienteIdSec: formulario.tipoCliente?.value,
            VendedorIdSecList: formulario.vendedor?.map((vendedor) => vendedor.value),
            TiendaIdSecList: formulario.tienda?.map((tienda) => tienda.value),
            Antiguedad: formulario.antiguedad?.value,
            FechaFin: fechaFin,
            Periodo: formulario.periodo?.value,
            MonedaIdSec: formulario.moneda?.value,
          };

          handleFiltrar(filtros);
        }}
        valorInicial={{
          periodo: { value: "EM", label: "Este mes" },
          tipo: "detalle",
        }}
        onChange={(formulario) => {
          setTipo(formulario?.tipo);

          handleChange(formulario);
        }}
        filtro={filtro}
        tipo={tipo}
        where={where}
      />
      {tipo === "detalle" && (
        <TablaSaldoAntiguedad
          facturas={facturas}
          loading={loading}
          expandedRows={expandedRows}
          setExpandedRows={setExpandedRows}
          indice={indice}
        />
      )}
      {tipo === "resumido" && (
        <TablaSaldoAntiguedadResumido
          facturas={facturas}
          loading={loading}
          filtrarFacturas={filtrarFacturas}
          indice={indice}
        />
      )}
      {indice < totalPaginas && (
        <Button2 loading={loading} onClick={handleMostrarMas} texto={loading ? "Cargando..." : "Mostrar más"} />
      )}
    </div>
  );
}